<template>
  <div class="textarea">
    <label :class="error ? 'error' : ''" :style="labelStyle">Descrição *</label>
    <textarea
      v-model="text"
      maxlength="200"
      @input="$emit('input', content)"
      :class="error ? 'error' : ''"
    ></textarea>
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <p v-if="error" class="error" :style="{ color: $themes.danger }">{{ errorMessage[0] }}</p>
      <p>{{ counter }} / 200</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      content: '',
    }
  },
  props: {
    value: {
      type: String,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    counter () {
      return this.content.length
    },
    labelStyle () {
      return {
        color: this.$themes.primary,
      }
    },
    text: {
      get () {
        return this.value
      },
      set (value) {
        this.content = value
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.textarea {
  width: 100%;
  position: relative;

  label {
    position: absolute;
    top: 0;
    left: 0.6rem;
    font-size: 0.625rem;
    text-transform: uppercase;
    font-weight: bold;
    z-index: 1;
    background-color: rgb(245, 248, 249);
    width: calc(100% - 1.75rem);
    padding-top: 0.25rem;

    &.error {
      background-color: rgba(227, 75, 74, 0.01);
      color: rgb(227, 75, 74) !important;
    }
  }

  textarea {
    width: 100%;
    height: 80px;
    border: 0;
    border-bottom: 1px solid rgb(131, 150, 165);
    border-radius: 0.5rem 0.5rem 0 0;
    background-color: rgb(245, 248, 249);
    resize: none;
    box-sizing: border-box;
    padding: 0.75rem;
    padding-top: 1.4rem;

    &.error {
      background-color: rgba(227, 75, 74, 0.2);
      border-bottom-color: rgb(227, 75, 74);
    }
  }

  p:not(.error) {
    text-align: right;
    font-size: 0.625rem;
    align-self: flex-end;
  }

  p.error {
    font-size: 0.8rem;
  }
}
</style>
